<template>
  <div class="enlargement-modal">
    <button
        class="enlargement-modal__close"
        @click="close"
    >
      <FontAwesomeIcon icon="fa-light fa-times"/>
    </button>
    <ClickWrapper
        class="enlargement-modal__container"
        ref="root"
    >
      <div class="enlargement-modal__image">
        <ResponsiveImage
            v-bind="componentProps"
        />
      </div>
    </ClickWrapper>
  </div>
</template>

<script lang="ts" setup>
import {
  computed,
} from 'vue';
import {
  useStore,
} from 'vuex';
import ClickWrapper from '@/components/ClickWrapper.vue';
import ResponsiveImage from '@/components/ResponsiveImage.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

library.add(faTimes);

const store = useStore();

const componentProps = computed(() => store.getters['enlargement/props']);

const close = (): void => {
  store.dispatch('enlargement/clear');
};
</script>

<style lang="scss">
@import 'src/scss/component-helpers';

.enlargement-modal {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 20000;
  background-color: transparentize(#000, .44);

  &__close {
    @include font-h3;
    font-size: inherit;
    border: 0;
    background: transparent;
    padding: 0;
    outline: 0;
    line-height: 1;
    color: #FFFFFF;
    position: absolute;
    top: 2em;
    right: 2em;
  }

  &__container {
    position: absolute;
    width: 55.5555%;
    min-width: 320px;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }

  &__image {
    max-height: 70vh;
    overflow: auto;
  }
}
</style>
